var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/finance/DivisionEnums';
let DivisionModule = class DivisionModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.wasFirstLoad = true;
        this.loading = false;
        this.loadPage = false;
        this.divisionList = [];
        this.page = 1;
        this.size = 10;
        this.pageFilter = 1;
        this.wasLoadQuickFilter = true;
        this.desc = '';
        this.searchBy = '';
        this.paging = [];
        this.status = '';
        this.statusMessage = '';
        this.selectedDivisionName = [];
        this.dropdownlistDivisionCode = [];
        this.dropdownlistDivisionName = [];
    }
    get getDivisionWasFirstLoad() {
        return this.wasFirstLoad;
    }
    get getDropdownlistDivisionCode() {
        return this.dropdownlistDivisionCode;
    }
    get getDropdownlistDivisionName() {
        return this.dropdownlistDivisionName;
    }
    get getDivisionLists() {
        return this.divisionList;
    }
    get getDivisionStatus() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getSelectedDivisionName() {
        return this.selectedDivisionName;
    }
    get getDivisionPaging() {
        return this.paging;
    }
    get getDivisionLoading() {
        return this.loading;
    }
    get getStatusDivision() {
        const status = {
            status: this.status,
            statusMessage: this.statusMessage
        };
        return status;
    }
    get getDivisionSize() {
        return this.size;
    }
    get getDivisionWasLoadQuickFilter() {
        return this.wasLoadQuickFilter;
    }
    get getDivisionDesc() {
        return this.desc;
    }
    get getDivisionSearchBy() {
        return this.searchBy;
    }
    [_a = Mutations.SET_DIVISION_LOAD](payload) {
        this.wasFirstLoad = payload;
    }
    [_b = Mutations.SET_SELECTED_DIVISION_NAME](payload) {
        this.selectedDivisionName = payload;
    }
    [_c = Mutations.SET_DIVISION_LIST](payload) {
        this.divisionList = payload;
    }
    [_d = Mutations.SET_DIVISION_LOADING](payload) {
        this.loading = payload;
    }
    [_e = Mutations.SET_DIVISION_HANDLE_PAGE](payload) {
        this.page = payload;
    }
    [_f = Mutations.SET_DIVISION_PAGE](payload) {
        this.paging = payload;
    }
    [_g = Mutations.SET_DIVISION_LOAD_PAGE]() {
        this.loadPage = true;
    }
    [_h = Mutations.SET_DIVISION_STATUS](payload) {
        this.status = payload.statusAssetNumber;
        this.statusMessage = payload.statusMessageAssetNumber;
    }
    [_j = Mutations.SET_DROPDOWNLIST_DIVISION_CODE](payload) {
        this.dropdownlistDivisionCode = payload;
    }
    [_k = Mutations.SET_DROPDOWNLIST_DIVISION_NAME](payload) {
        this.dropdownlistDivisionName = payload;
    }
    [_l = Mutations.SET_DIVISION_SIZE](payload) {
        this.size = payload;
    }
    [_m = Mutations.SET_DIVISION_HANDLE_SIZE](payload) {
        this.size = payload;
    }
    [_o = Mutations.SET_DIVISION_PAGE_FILTER](payload) {
        this.pageFilter = payload;
    }
    [_p = Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER](payload) {
        this.wasLoadQuickFilter = payload;
    }
    [_q = Mutations.SET_DIVISION_DESC](payload) {
        this.desc = payload;
    }
    [_r = Mutations.SET_DIVISION_SEARCH_BY](payload) {
        this.searchBy = payload;
    }
    [_s = Actions.GET_DIVISION_LIST]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_LOADING, false);
            const params = {
                ver: 'v1'
            };
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/division/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.page.toString(),
                Size: this.size.toString(),
                divisionName: this.selectedDivisionName,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    var _y, _z;
                    if (res.status === 200) {
                        this.context.commit(Mutations.SET_DIVISION_LIST, ((_y = res.data.result.content) === null || _y === void 0 ? void 0 : _y.data) || []);
                        this.context.commit(Mutations.SET_DIVISION_LOAD_PAGE, true);
                        this.context.commit(Mutations.SET_DIVISION_PAGE, ((_z = res.data.result.content) === null || _z === void 0 ? void 0 : _z.paging) || {
                            currentPage: 0,
                            totalPages: 0,
                            totalElements: 0,
                            errorRows: 0,
                            readyToUpload: 0
                        });
                        this.context.commit(Mutations.SET_DIVISION_LOADING, false);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DIVISION_LOADING, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    reject(false);
                });
            });
        });
    }
    [_t = Actions.GET_DIVISION_LIST_ALLDATA]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, false);
            const params = {
                ver: 'v1'
            };
            const dataListDivisionCode = [...this.dropdownlistDivisionCode];
            const dataListDivisionName = [...this.dropdownlistDivisionName];
            const url = process.env.VUE_APP_BASE_URL_DIGITAL +
                `/fincapex/api/master/division/filter?` +
                new URLSearchParams(params).toString();
            const paramsData = {
                Page: this.pageFilter.toString(),
                Size: '10',
                Desc: this.desc,
                SearchBy: this.searchBy,
                isActive: true
            };
            return new Promise((resolve, reject) => {
                ApiService.post(url, paramsData)
                    .then((res) => {
                    if (res.status === 200) {
                        if (res.data.result.content !== null) {
                            if (res.data.result.content.paging.totalPages === this.pageFilter) {
                                this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, false);
                            }
                            else {
                                this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, true);
                            }
                            res.data.result.content.data.map((data) => {
                                dataListDivisionCode.push({
                                    value: data.divisionCode,
                                    label: data.divisionCode
                                });
                                dataListDivisionName.push({
                                    value: data.divisionName,
                                    label: data.divisionName
                                });
                            });
                        }
                        else {
                            this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, false);
                        }
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_CODE, dataListDivisionCode);
                        this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_NAME, dataListDivisionName);
                        resolve(true);
                    }
                    else {
                        this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, false);
                        reject(false);
                    }
                })
                    .catch((err) => {
                    this.context.commit(Mutations.SET_DIVISION_WAS_LOAD_QUICK_FILTER, false);
                    reject(false);
                });
            });
        });
    }
    [_u = Actions.UPDATE_DIVISION_SIZE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_SIZE, data);
            this.context.commit(Mutations.SET_DIVISION_HANDLE_PAGE, 1);
            this.context.dispatch(Actions.GET_DIVISION_LIST);
        });
    }
    [_v = Actions.UPDATE_DIVISION_PAGE_FILTER]() {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_PAGE_FILTER, this.pageFilter + 1);
        });
    }
    [_w = Actions.UPDATE_DIVISION_CODE](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_SEARCH_BY, data === '' ? '' : 'divisioncode');
            this.context.commit(Mutations.SET_DIVISION_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_NAME, []);
            this.context.commit(Mutations.SET_DIVISION_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DIVISION_LIST_ALLDATA);
        });
    }
    [_x = Actions.UPDATE_DIVISION_DESC](data) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit(Mutations.SET_DIVISION_SEARCH_BY, data === '' ? '' : 'divisionname');
            this.context.commit(Mutations.SET_DIVISION_DESC, data);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_CODE, []);
            this.context.commit(Mutations.SET_DROPDOWNLIST_DIVISION_NAME, []);
            this.context.commit(Mutations.SET_DIVISION_PAGE_FILTER, 1);
            this.context.dispatch(Actions.GET_DIVISION_LIST_ALLDATA);
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _a, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _b, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _c, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _d, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _e, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _f, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _g, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _h, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _j, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _k, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _l, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _m, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _o, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _p, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _q, null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], DivisionModule.prototype, _r, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _s, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _t, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _u, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _v, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _w, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], DivisionModule.prototype, _x, null);
DivisionModule = __decorate([
    Module
], DivisionModule);
export default DivisionModule;
